import React from 'react';
import { string, shape } from 'prop-types';
var ApssFlyerBanner = function ApssFlyerBanner(_ref) {
  var staticProps = _ref["static"];
  var bannerKey = staticProps.bannerKey;
  var content = "\n    !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src=\"https://websdk.appsflyer.com?\"+(c.length>0?\"st=\"+c.split(\",\").sort().join(\",\")+\"&\":\"\")+(i.length>0?\"af_id=\"+i:\"\"),p.parentNode.insertBefore(o,p)}(window,document,\"script\",0,\"AF\",\"banners\",{banners: {key: \"".concat(bannerKey, "\"}});\n    AF('banners', 'showBanner')\n  ");
  return React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
ApssFlyerBanner.ssr = true;
process.env.NODE_ENV !== "production" ? ApssFlyerBanner.propTypes = {
  "static": shape({
    bannerKey: string.isRequired
  }).isRequired
} : void 0;
export default ApssFlyerBanner;